module.exports = __webpack_public_path__ + "static/media/location-img.0e40120c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/location-img.svg
// module id = 142
// module chunks = 0